/* Clara Ribera - ficha de producto: variantes, galería, descripción estructurada y añadir al carrito lateral. */
(function(){
var root=document.getElementById('cr-pdp');if(!root)return;
var dataEl=root.querySelector('[data-product]');if(!dataEl)return;
var P=JSON.parse(dataEl.textContent);
var fmt=new Intl.NumberFormat('es-ES',{style:'currency',currency:'EUR'});
var num=new Intl.NumberFormat('es-ES',{minimumFractionDigits:2,maximumFractionDigits:2});
var saveEl=root.querySelector('[data-save]');
function eur(c){return fmt.format(c/100)}
/* Descripción: estructura visual (subtítulos en mayúsculas, viñetas y párrafos cortos) para cualquier texto de producto */
var BIG=/^(3XL|4XL|5XL|6XL|7XL|8XL|9XL|XXXL|XXXXL)$/i;
function trimSizes(t){
[].slice.call(t.rows).forEach(function(tr){var c=tr.cells[0];if(c&&BIG.test(c.textContent.trim()))tr.remove()});
var hr=t.rows[0];if(!hr)return;
for(var i=hr.cells.length-1;i>=0;i--){if(BIG.test(hr.cells[i].textContent.trim())){[].slice.call(t.rows).forEach(function(r){if(r.cells[i])r.deleteCell(i)})}}
}
function crStructure(desc,guide){
var kids=function(){return [].slice.call(desc.children)};
desc.querySelectorAll('[dir]').forEach(function(e){e.removeAttribute('dir')});
desc.querySelectorAll('[role="presentation"]').forEach(function(e){e.removeAttribute('role')});
var again=true;while(again){again=false;kids().forEach(function(d){if(d.tagName==='DIV'||d.tagName==='SECTION'){while(d.firstChild)desc.insertBefore(d.firstChild,d);d.remove();again=true}})}
desc.querySelectorAll('table').forEach(function(t){
trimSizes(t);
if(!guide)return;
var prev=t.previousElementSibling;
var box=document.createElement('div');box.className='cr-sizetable';
if(prev&&prev.tagName==='P'&&/talla|medida/i.test(prev.textContent)&&prev.textContent.trim().length<60){var h=document.createElement('p');h.innerHTML='<b>'+prev.textContent.replace(/^[^A-Za-zÁÉÍÓÚÑáéíóúñ]+/,'').trim()+'</b>';box.appendChild(h);prev.remove()}
box.appendChild(t);guide.insertBefore(box,guide.firstChild);
var fb=guide.querySelector('[data-guide-fallback]');if(fb)fb.remove();
});
desc.querySelectorAll('h1,h2,h4,h5,h6').forEach(function(x){var h=document.createElement('h3');h.textContent=x.textContent.trim();x.replaceWith(h)});
desc.querySelectorAll('p').forEach(function(p){
if(p.closest('li'))return;
var parts=p.innerHTML.split(/<br\s*\/?>/i).map(function(x){return x.trim()}).filter(function(x){return x.replace(/&nbsp;/g,'').replace(/<[^>]+>/g,'').trim()});
if(parts.length>1){parts.forEach(function(h){var n=document.createElement('p');n.innerHTML=h;p.before(n)});p.remove()}
});
desc.querySelectorAll('p').forEach(function(p){
if(p.closest('li'))return;
var t=p.textContent.replace(/ /g,' ').trim();
if(!t&&!p.querySelector('img')){p.remove();return}
if(t.length<160&&(/^(🚚|↩|🔒|💳|✈|📦)/.test(t)||/^(envío|envio)\s+(gratis|gratuito)|^\d+\s+días\s+para|^pago\s+(100\s*%\s+)?seguro/i.test(t.replace(/^[^A-Za-zÁÉÍÓÚÑáéíóúñ0-9]+/,'')))){p.remove();return}
var s=p.querySelector('strong,b');
if(s&&s.textContent.trim()===t&&t.length<=60){var h=document.createElement('h3');h.textContent=t.replace(/[.:]$/,'');p.replaceWith(h);return}
var nx=p.nextElementSibling;
if(/:$/.test(t)&&t.length<=60&&nx&&(nx.tagName==='UL'||nx.tagName==='OL')){var h2=document.createElement('h3');h2.textContent=t.replace(/:$/,'');p.replaceWith(h2)}
});
desc.querySelectorAll('h3').forEach(function(h){var t=h.textContent.trim();if(t.length>70){var p=document.createElement('p');p.innerHTML='<strong>'+t+'</strong>';h.replaceWith(p)}});
var BUL=/^\s*(✔️?|✓|✅|☑️?|•|·|▪️?|-|–|—|\*)\s*/;
function isBullet(p){
if(p.tagName!=='P'||p.closest('li'))return false;
var t=p.textContent.trim();
if(BUL.test(t)&&t.replace(BUL,'').length>2)return 'sym';
var f=p.firstElementChild;
if(f&&(f.tagName==='STRONG'||f.tagName==='B'||f.tagName==='SPAN')&&p.innerHTML.trim().indexOf('<'+f.tagName.toLowerCase())===0){var lab=f.textContent.trim();var after=t.slice(t.indexOf(lab)+lab.length);if(lab.length>=2&&lab.length<=46&&(/:$/.test(lab)||/^\s*:/.test(after))&&after.replace(/^\s*:/,'').trim().length>3)return 'lab'}
if(f&&(f.tagName==='STRONG'||f.tagName==='B')&&p.innerHTML.trim().indexOf('<'+f.tagName.toLowerCase())===0){var l2=f.textContent.trim();if(l2.length>=3&&l2.length<=40&&l2!==t&&t.length<=160)return 'lead'}
return false;
}
var group=[];
function flush(){
var strong=group.some(function(g){return g._k!=='lead'});
if((strong&&group.length>=2)||group.length>=3){var ul=document.createElement('ul');group[0].before(ul);group.forEach(function(p){var li=document.createElement('li');li.innerHTML=p.innerHTML.replace(/^\s*(✔️?|✓|✅|☑️?|•|·|▪️?|-|–|—|\*)\s*/,'');ul.appendChild(li);p.remove()})}
group=[];
}
kids().forEach(function(e){var k=isBullet(e);if(k){e._k=k;group.push(e)}else flush()});flush();
desc.querySelectorAll('h3').forEach(function(h){h.textContent=h.textContent.trim().replace(/\s*:$/,'')});
desc.querySelectorAll('p').forEach(function(p){
if(p.closest('li')||p.querySelector('img'))return;
var t=p.textContent.trim();
if(t.length<230)return;
var ss=p.innerHTML.replace(/([.!?]["»”]?(?:<\/(?:strong|b|em|i|span)>)?)\s+(?=(?:<(?:strong|b|em|i|span)[^>]*>)?[A-ZÁÉÍÓÚÑ¡¿])/g,'$1\u0001').split('\u0001');
if(ss.length<2)return;
var cur='',tmp=document.createElement('div'),out=[];
ss.forEach(function(x){cur=cur?cur+' '+x:x;tmp.innerHTML=cur;if(tmp.textContent.length>=150){out.push(cur);cur=''}});
if(cur){tmp.innerHTML=cur;if(out.length&&tmp.textContent.length<60)out[out.length-1]+=' '+cur;else out.push(cur)}
if(out.length<2)return;
out.forEach(function(h){var n=document.createElement('p');n.innerHTML=h.trim();p.before(n)});
p.remove();
});
desc.querySelectorAll('li').forEach(function(li){
var inner=li.querySelector(':scope > p');if(inner)li.innerHTML=inner.innerHTML;
li.innerHTML=li.innerHTML.replace(/(<br\s*\/?>\s*)+$/i,'').replace(/^\s*(✔️?|✓|✅|☑️?|•|·|▪️?)\s*/,'').trim();
li.innerHTML=li.innerHTML.replace(/^(<(?:strong|b)>)\s*[-–—•]\s*/,'$1');
var sp=li.querySelector(':scope > span:first-child');if(sp&&/:\s*$/.test(sp.textContent)){var b=document.createElement('strong');b.textContent=sp.textContent.trim();sp.replaceWith(b)}
if(!li.querySelector('strong,b')){var m=li.innerHTML.match(/^([^:<]{3,45}):\s*/);if(m)li.innerHTML='<strong>'+m[1]+':</strong> '+li.innerHTML.slice(m[0].length)}
});
if(!desc.querySelector('h3')){
var ul0=desc.querySelector(':scope > ul,:scope > ol');
var ps=desc.querySelectorAll(':scope > p');
var at=ul0||(ps.length>=3?ps[1]:null);
if(at){var hh=document.createElement('h3');hh.textContent='Por qué te va a encantar';at.before(hh)}
}
var f0=desc.firstElementChild;
if(f0&&f0.tagName==='P'&&!f0.querySelector('img')&&f0.textContent.trim().length<150&&/[?!¡¿]/.test(f0.textContent))f0.classList.add('cr-lead');
var tw=document.createTreeWalker(desc,NodeFilter.SHOW_TEXT);var tn;
while((tn=tw.nextNode())){if(/[3-9]XL/.test(tn.nodeValue))tn.nodeValue=tn.nodeValue.replace(/\b(a la|hasta la|hasta|y)\s+[3-9]XL\b/gi,'$1 2XL')}
}
var desc=root.querySelector('[data-desc]');
if(desc){try{crStructure(desc,root.querySelector('#cr-tallas .cr-acc-body'))}catch(e){}}
root.querySelectorAll('#cr-tallas table').forEach(function(t){try{trimSizes(t)}catch(e){}});

var COL={'negro':'#111','blanco':'#fff','gris':'#8a8a8a','beige':'#d9c7a7','marrón':'#6b4a33','marron':'#6b4a33','camel':'#c19a6b','caqui':'#a99b6a','tostado':'#a67b5b','café':'#6f4e37','albaricoque':'#f2b38a','azul':'#3b5b8c','azul marino':'#1f2a44','azul oscuro':'#22325a','azul cielo':'#9cc3e0','azul celeste':'#9cc3e0','rosa':'#e8a5b5','rosa palo':'#e7c3c3','rojo':'#b3262e','burdeos':'#6e1f2e','granate':'#6e1f2e','marrón rojizo':'#8b3a2b','verde':'#4f7a52','verde oscuro':'#2f4f3a','verde militar':'#4b5320','oliva':'#6b6b3a','verde oliva':'#6b6b3a','morado':'#6a3d7a','amarillo':'#e3c04a','mostaza':'#c9a227','crema':'#f3ead8','lila':'#b9a2cf'};
var opts=[].slice.call(root.querySelectorAll('[data-opt]'));
var sizeIdx=-1,colorIdx=-1;
(P.options||[]).forEach(function(o,i){var n=(o.name||o).toString().toLowerCase();if(/talla|size/.test(n))sizeIdx=i;if(/color|colour/.test(n))colorIdx=i});
root.querySelectorAll('[data-c]').forEach(function(i){var c=COL[(i.getAttribute('data-c')||'').toLowerCase().trim()];var b=i.closest('.cr-val');var isCol=b&&b.closest('[data-opt]')&&+b.closest('[data-opt]').getAttribute('data-opt')===colorIdx;if(c&&isCol){i.style.background=c;i.hidden=false;b.classList.add('sw');b.setAttribute('title',i.getAttribute('data-c'))}else{i.remove()}});
var single=P.variants.length===1;
var sel=[];
var params=new URLSearchParams(location.search),vid=params.get('variant'),start=null;
if(vid)start=P.variants.find(function(x){return String(x.id)===vid});
if(!start)start=P.variants.find(function(x){return x.available})||P.variants[0];
if(!single)opts.forEach(function(fs,i){var n=fs.querySelectorAll('.cr-val').length;if(vid||i!==sizeIdx||n===1)sel[i]=start.options[i]});
var slides=root.querySelector('[data-slides]'),dots=[].slice.call(root.querySelectorAll('[data-dots] button')),thumbs=[].slice.call(root.querySelectorAll('[data-thumbs] button')),sl=slides?[].slice.call(slides.children):[];
var atc=root.querySelector('[data-atc]'),hint=root.querySelector('[data-hint]'),idIn=root.querySelector('[data-id]'),priceEl=root.querySelector('[data-price]'),stickP=root.querySelector('[data-stick-price]'),stickB=root.querySelector('[data-stick-btn]');
function current(){if(single)return P.variants[0];return P.variants.find(function(x){return x.options.every(function(o,i){return sel[i]===o})})||null}
function go(i){if(!slides||!sl[i])return;slides.scrollTo({left:sl[i].offsetLeft-slides.offsetLeft,behavior:'smooth'})}
function goMedia(id){if(!id)return;var k=sl.findIndex(function(s){return s.getAttribute('data-media-id')===String(id)});if(k>-1)go(k)}
function mark(k){dots.forEach(function(d,j){d.classList.toggle('on',j===k)});thumbs.forEach(function(d,j){d.classList.toggle('on',j===k)})}
if(slides){slides.addEventListener('scroll',function(){var k=Math.round(slides.scrollLeft/slides.clientWidth);mark(k)},{passive:true})}
dots.forEach(function(d,j){d.addEventListener('click',function(){go(j)})});
thumbs.forEach(function(d,j){d.addEventListener('click',function(){go(j);mark(j)})});
function setPrice(x){
var cp=x.compare_at_price||0,pr=x.price,h='';
if(cp>pr){var pc=Math.round((1-pr/cp)*100);h='<s>'+eur(cp)+'</s><strong>'+eur(pr)+'</strong><em>-'+pc+'%</em>'}else{h='<strong>'+eur(pr)+'</strong>'}
priceEl.innerHTML=h;stickP.textContent=eur(pr);
if(saveEl){if(cp>pr){saveEl.textContent='Ahorras '+num.format((cp-pr)/100)+' €';saveEl.hidden=false}else{saveEl.hidden=true}}
}
function update(){
opts.forEach(function(fs,i){
fs.querySelector('[data-opt-label]').textContent=sel[i]||'';
fs.querySelectorAll('.cr-val').forEach(function(b){
var val=b.getAttribute('data-value');
b.setAttribute('aria-pressed',String(val===sel[i]));
var ok=P.variants.some(function(x){return x.available&&x.options[i]===val&&x.options.every(function(o,j){return j===i||sel[j]==null||sel[j]===o})});
b.classList.toggle('off',!ok);
});
});
var x=current();
setPrice(x||start);
if(!x){atc.textContent=sizeIdx>-1&&sel[sizeIdx]==null?'Elige tu talla':'Elige una opción';atc.disabled=true;stickB.textContent=atc.textContent;stickB.disabled=false;stickB.setAttribute('data-pick','1');return}
stickB.removeAttribute('data-pick');
idIn.value=x.id;
if(!x.available){atc.textContent='Agotado';atc.disabled=true;stickB.textContent='Agotado';stickB.disabled=true}
else{atc.textContent='Añadir al carrito';atc.disabled=false;stickB.textContent='Añadir al carrito';stickB.disabled=false}
if(!single&&history.replaceState){var u=new URL(location.href);u.searchParams.set('variant',x.id);history.replaceState(null,'',u)}
}
opts.forEach(function(fs,i){fs.addEventListener('click',function(e){
var b=e.target.closest('.cr-val');if(!b)return;
sel[i]=b.getAttribute('data-value');hint.textContent='';
fs.querySelectorAll('.cr-val').forEach(function(z){z.classList.remove('need')});
if(i===colorIdx){var f=P.variants.find(function(x){return x.options[i]===sel[i]&&x.featured_media});if(f)goMedia(f.featured_media.id)}
update();
})});
var sg=root.querySelector('[data-sizeguide]');
if(sg)sg.addEventListener('click',function(){var d=document.getElementById('cr-tallas');if(d){d.open=true;d.scrollIntoView({behavior:'smooth',block:'start'})}});
function setCount(n){root.querySelectorAll('[data-cart-count]').forEach(function(c){c.textContent=n>0?n:''})}
function add(id,done,fail){
var items=[{id:Number(id),quantity:1}];
var msg='No se ha podido añadir. Inténtalo de nuevo.';
if(window.crCart&&window.crCart.add){
window.crCart.add(items).then(function(c){setCount(c.item_count);if(done)done()}).catch(function(e){if(fail)fail((e&&e.message)||msg)});
return;
}
fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
.then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
.then(function(){location.href='/cart'})
.catch(function(e){if(fail)fail((e&&(e.description||e.message))||msg)});
}
function needChoice(){
var miss=opts.findIndex(function(fs,i){return sel[i]==null});
if(miss<0)return false;
hint.textContent=miss===sizeIdx?'Elige tu talla para añadirla al carrito.':'Elige una opción para añadirla al carrito.';
opts[miss].querySelectorAll('.cr-val').forEach(function(z){z.classList.add('need')});
opts[miss].scrollIntoView({behavior:'smooth',block:'center'});
return true;
}
function buy(){
if(needChoice())return;
var x=current();if(!x||!x.available)return;
atc.disabled=true;atc.textContent='Añadiendo…';
add(x.id,function(){update()},function(m){hint.textContent=m;update()});
}
root.querySelector('[data-form]').addEventListener('submit',function(e){e.preventDefault();buy()});
stickB.addEventListener('click',function(){if(stickB.hasAttribute('data-pick')){needChoice();return}buy()});
var stick=root.querySelector('[data-stick]');
if('IntersectionObserver' in window){new IntersectionObserver(function(en){var b=en[0];var show=!b.isIntersecting&&b.boundingClientRect.top<0;stick.classList.toggle('show',show);stick.setAttribute('aria-hidden',String(!show))}).observe(atc)}
var zb=root.querySelector('[data-zoombox]'),zi=zb.querySelector('img');
sl.forEach(function(s){s.addEventListener('click',function(){zi.src=s.getAttribute('data-zoom');zi.alt=s.querySelector('img').alt;zb.classList.add('open');zb.setAttribute('aria-hidden','false');document.body.style.overflow='hidden'})});
function zclose(){zb.classList.remove('open');zb.setAttribute('aria-hidden','true');document.body.style.overflow=''}
zb.querySelector('[data-zoomclose]').addEventListener('click',zclose);
zb.addEventListener('click',function(e){if(e.target===zb)zclose()});
document.addEventListener('keydown',function(e){if(e.key==='Escape')zclose()});
fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){setCount(c.item_count)}).catch(function(){});
update();
if(vid&&start.featured_media)goMedia(start.featured_media.id);
})();